import { useState } from "react";
import { api } from "../../../lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export function VisitSchedule({ quoteId, data, onChanged }) {
  const [busy, setBusy] = useState(false);

  const setWhen = async (field, stage, value) => {
    setBusy(true);
    try {
      const iso = value ? new Date(value).toISOString() : "";
      await api.put("/admin/prospect/stage", { kind: "quote", id_or_ref: quoteId, stage, [field]: iso });
      toast.success(field === "site_talk_at" ? "Site visit scheduled" : "Survey scheduled");
      if (onChanged) onChanged({ [field]: iso, stage });
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
    setBusy(false);
  };

  const toLocal = (v) => v ? new Date(v).toISOString().slice(0, 16) : "";

  return (
    <div className="space-y-4" data-testid="jobfile-visit-schedule">
      <div className="border border-[#E5E7EB] bg-white p-4">
        <div className="label-eyebrow mb-3">Schedule</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <label className="label-eyebrow block mb-1">Site visit (1hr initial visit)</label>
            <input type="datetime-local" data-testid="quote-detail-site-talk-at" disabled={busy}
              value={toLocal(data.site_talk_at)}
              onChange={(e) => setWhen("site_talk_at", "site_visit", e.target.value)}
              className="w-full border border-[#E5E7EB] px-3 py-2 text-sm" />
            <p className="text-[10px] text-[#9CA3AF] mt-1">Setting a date moves the file to the <b>Site visit</b> stage.</p>
          </div>
          <div>
            <label className="label-eyebrow block mb-1">In-depth survey</label>
            <input type="datetime-local" data-testid="quote-detail-survey-at" disabled={busy}
              value={toLocal(data.survey_at)}
              onChange={(e) => setWhen("survey_at", "survey", e.target.value)}
              className="w-full border border-[#E5E7EB] px-3 py-2 text-sm" />
            <p className="text-[10px] text-[#9CA3AF] mt-1">Setting a date moves the file to the <b>Survey</b> stage.</p>
          </div>
        </div>
      </div>

      <div className="border border-dashed border-[#E5E7EB] bg-[#F8F6F2] p-4 flex items-start gap-3" data-testid="survey-form-locked-note">
        <Lock size={15} className="text-[#6B7280] mt-0.5 shrink-0" />
        <p className="text-xs text-[#6B7280]">
          The full <b>survey form</b> (verify dimensions, auto re-price, site checks, AI-priced extras) unlocks
          once the client books — pay £499 online, or book it from the <b>Money</b> tab with the fee deferred or waived.
        </p>
      </div>
    </div>
  );
}
